import React from "react";
import {Module as ModuleProd} from "../DOOP";

export const Module: React.FC = () => <ModuleProd/>;
